(function () {
  'use strict';

  angular
      .module('tfc.sso')
      .controller('PasswordResetCtrl', PasswordResetCtrl);

  // @ngInject
  function PasswordResetCtrl($state, Auth, Toast) {
    var vm = this;

    var user = Auth.getUser();

    vm.isAuthenticated = function () {
      return !!user;
    };

    vm.user = {
      user : $state.params.email || (user && user.email)
    };

    vm.error = null;

    vm.save = function () {
      vm.error = null;
      Auth.resetPassword(vm.user).then(function () {
        Toast.success('Password successfully changed');
        $state.go('login');
      });
    };
  }

})();
